import { Component, OnInit, output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-retryconnectionerror.content.json';

@Component({
    selector: 'conversational-chat-retryconnectionerror',
    templateUrl: './conversational-chat-retryconnectionerror.component.html',
    standalone: false
})
export class ConversationalChatRetryconnectionerrorComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public refreshComponent = output<void>();

    public setRefreshComponent(): void {
        this.refreshComponent.emit();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }
}
